module.exports = __webpack_public_path__ + "static/img/作品13.9a50f59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品13.png
// module id = QsTj
// module chunks = 1